import { useState } from 'react'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TextAreaField from '../../../FormLegacy/FormFieldsV2/TextAreaField'
import Icon from '../../../Icons'

const DescriptionModal = ({
  description,
  setDescription,
  handleCancel,
  updateDescriptionData,
  title,
  name,
  placeholder,
}) => {
  const { t } = useTranslation(['maintenance', 'common'])
  const [isEditModeEnabled, setIsEditModeEnabled] = useState(false)

  const editDescription = () => {
    updateDescriptionData({ [name]: description })
    setIsEditModeEnabled(false)
    handleCancel()
  }

  return (
    <div className="maintenance-request-description">
      <div className="maintenance-request-description__container">
        <div className="window-header">
          <div className="title">
            {isEditModeEnabled
              ? t('maintenance:requestPreview.descriptionModal.editTitle', { title })
              : title}
          </div>
          <div className="navi-button" onClick={() => handleCancel()}>
            <Icon icon="cross" />
          </div>
        </div>
        <div className="main-view">
          {isEditModeEnabled ? (
            <TextAreaField
              name={name}
              placeholder={placeholder}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              maxLength="500"
              style={{ width: '100%' }}
            />
          ) : (
            <p>{description}</p>
          )}
        </div>
        <div className="window-footer">
          <div className="footer-buttons">
            <button className={'button button-gray is-block'} onClick={() => handleCancel()}>
              {t('common:actions.cancel')}
            </button>
            {isEditModeEnabled ? (
              <button
                onClick={() => editDescription()}
                className={'button button-primary is-block'}
              >
                {t('common:actions.save')}
              </button>
            ) : (
              <button
                onClick={() => setIsEditModeEnabled(true)}
                className={'button button-primary is-block'}
              >
                {t('common:actions.edit')}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

DescriptionModal.propTypes = {
  description: PropTypes.string,
  setDescription: PropTypes.func,
  handleCancel: PropTypes.func,
  maintenanceId: PropTypes.number,
  updateDescriptionData: PropTypes.func,
  title: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
}

export default DescriptionModal
